import { removeFromBox, upsertBox } from 'common/Prose/Commands/boxAndQuotes'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { isTableSelection } from 'common/Prose/utils/table'
import { last } from 'lodash'
import { comparer, computed } from 'mobx'
import { schema } from 'prose-core'
import { useContext } from 'react'
import { AlmanacEditorStateContext, SelectionType } from 'stores/EditorState'

export const useQuoteButton = () => {
  const view = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const disabled = computed(
    () =>
      almanacState.activeNodes.has(schema.nodes.code_block) ||
      almanacState.selectionType === SelectionType.Cell ||
      isTableSelection(almanacState.selection),
  ).get()

  const { activeColors, active } = computed(
    () => {
      const { selection } = almanacState
      const { doc } = view.state
      const colors: string[] = []

      for (const range of selection.ranges) {
        doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos, parent) => {
          if (node.type === schema.nodes.box) {
            const { quoteColor } = node.attrs
            if (quoteColor && last(colors) !== quoteColor) colors.push(quoteColor)
            // Don't further descend into blocks past depth of 1
            return false
          }
        })
      }

      return { activeColors: colors, active: colors.length > 0 }
    },
    { equals: comparer.structural },
  ).get()

  const setColor = (color: string) => {
    const tr = upsertBox(view.state, undefined, color)
    view.dispatch(tr)
    view.focus()
  }

  const removeColor = () => {
    const { state } = view
    const { tr } = state

    removeFromBox(state, tr, { quote: true })
    view.dispatch(tr)
    view.focus()
  }

  return { activeColors, active, disabled, setColor, removeColor }
}
